import request from '../../utils/request'
// 未签约 续费签约/保单签约
const putEntrust = (uuid,data) => {
    return request({
        url: process.env.VUE_APP_TRADER + `order/entrust/common/${uuid}`,
        method: 'post',
        data
    })
}
// 保单已签约 去续费
const entrustPay = (uuid) => {
    return request({
        url: process.env.VUE_APP_TRADER + `order/entrust/pay/${uuid}?sjc=${Date.parse(new Date())}`,
        method: 'get',
    })
}
export {
    putEntrust,
    entrustPay
}